import { GetFieldLabel } from "../utils/GetFieldLabel";

export class QDBTypeInfo {
  constructor(fieldDef) {
    this.fFieldID = fieldDef.GetFieldID();
    this.fFieldName = fieldDef.GetFieldName();
    this.fFieldType = fieldDef.GetFieldType();
    this.fCalcCode = fieldDef.GetCalcCode();
    this.fNumDecimals = fieldDef.GetNumDecPlaces();
    this.fShowPercent = fieldDef.GetShowPercent();
    this.fShowThousandsSep = fieldDef.GetShowThousandsSep();
    this.fPrefix = fieldDef.GetPrefix();
    this.fPostfix = fieldDef.GetPostfix();
    this.fPriorFieldDef = fieldDef;
    this.fUserAdded = fieldDef.GetManualAdd();
    this.fBreakChars = fieldDef.GetBreakChars();
    this.fHyperlinkType = fieldDef.GetHyperlinkType();
    this.fFieldLabel = fieldDef.GetFieldLabel();
    this.fDateFormat = fieldDef.GetDateFormat();

    var rule = fieldDef.GetFormulaRule();
    if (rule) this.fFormulaRule = rule.Clone();
    else this.fFormulaRule = null;
  }

  CopyInfoToFieldDef(fieldDef) {
    //  fieldDef.SetFieldName(this.fFieldType);
    fieldDef.SetFieldType(this.fFieldType);
    fieldDef.SetNumDecPlaces(this.fNumDecimals);
    fieldDef.SetShowPercent(this.fShowPercent);
    fieldDef.SetShowThousandsSep(this.fShowThousandsSep);
    fieldDef.SetPrefix(this.fPrefix);
    fieldDef.SetPostfix(this.fPostfix);
    fieldDef.SetBreakChars(this.fBreakChars);
    fieldDef.SetHyperlinkType(this.fHyperlinkType);
    fieldDef.SetCalcCode(this.fCalcCode);
    fieldDef.SetFieldLabel(this.fFieldLabel);
    fieldDef.SetDateFormat(this.fDateFormat);
  }
}
